"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Box_1 = require("@material-ui/core/Box");
var core_1 = require("@material-ui/core");
var customCheckboxStyles_1 = require("./customCheckboxStyles");
var ShowIfTranslationExists_1 = require("../../../common/components/ShowIfTranslationExists");
var react_intl_1 = require("react-intl");
var ConsentSelector_1 = require("./consentSelector/ConsentSelector");
exports.CustomCheckbox = function (_a) {
    var formData = _a.formData;
    var _b;
    var styles = customCheckboxStyles_1.default();
    var label = formData.label, id = formData.id;
    var termsWithUrl = react_1.useMemo(function () {
        return (<core_1.Typography className={styles.disclaimer} dangerouslySetInnerHTML={{ __html: label }} onClick={function (e) {
            if (!e.target.hasAttribute('href')) {
                e.preventDefault();
            }
        }} data-test={"text:enquiryForm:" + id}/>);
    }, [label]);
    var intl = react_intl_1.useIntl();
    return (<Box_1.default width={'100%'}>
      <ShowIfTranslationExists_1.default translationKey={'enquiryForm.aboveTermsText'}>
        <Box_1.default className={styles.note}>
          <core_1.Typography component={'p'}>{intl.formatMessage({ id: 'enquiryForm.aboveTermsText' })}</core_1.Typography>
        </Box_1.default>
      </ShowIfTranslationExists_1.default>
      <Box_1.default flex={true} flexDirection={((_b = formData.schema) === null || _b === void 0 ? void 0 : _b.explicitConsent) ? 'column-reverse' : 'row'} className={styles.formControlContainer}>
        <ConsentSelector_1.default formData={formData}/>
        <Box_1.default>
          <core_1.Typography component={'span'} data-test={"checkbox:label:" + id}>
            {termsWithUrl}
          </core_1.Typography>
        </Box_1.default>
      </Box_1.default>
    </Box_1.default>);
};
exports.default = exports.CustomCheckbox;
